import { render } from "./DeleteDialog.vue?vue&type=template&id=411bd480&scoped=true"
import script from "./DeleteDialog.vue?vue&type=script&lang=js"
export * from "./DeleteDialog.vue?vue&type=script&lang=js"

import "./DeleteDialog.vue?vue&type=style&index=0&id=411bd480&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-411bd480"]])

export default __exports__